
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[...params]",
      function () {
        return require("private-next-pages/categories/[...params].tsx");
      }
    ]);
  